import React, { Component } from 'react';
import { Tabs } from 'antd';
import { withRouter } from 'react-router-dom';
import {
  isExternalContributorOrExternalView,
  isCreatorOrAdministrator,
  isIPSDataCreatorOrAdministrator,
} from '../../../utils/UserInfo';
import CommToolContext from 'containers/common/comm_tool_context';

const TabPane = Tabs.TabPane;
const padfix = {
  margin: '15px 15px 15px 0px',
  width: '100%',

};

const navMenuHeaderStyle = {
  style1: {
    padding: '12px',
    backgroundColor: '#0CA0DA',
    color: 'rgb(255, 255, 255)'
  },
  style0: {
    padding: '12px',
    backgroundColor: '#f0f0f0'
  }
}

class ProjectTabRoutes extends Component {
  render() {
    const { history, match, status, context } = this.props;
    const applicationMenu = context.state.userProfile && context.state.userProfile.applicationMenu;
    const dtApplicationMenu = applicationMenu === 'DATA_ENTRY_TRACKER' || applicationMenu === 'ALL' || !applicationMenu
    const tclApplicationMenu = applicationMenu === 'CHECKLIST' || applicationMenu === 'ALL' || !applicationMenu
    const fmpApplicationMenu = applicationMenu === 'FMP_TRACKER' || applicationMenu === 'ALL' || !applicationMenu
    return (
      <>
        <div className='container-fluid'>
          {!isExternalContributorOrExternalView() && dtApplicationMenu && <Tabs
            centered
            defaultActiveKey={match.params.tabId}
            onTabClick={(key) =>
              history.push({
                pathname: `/dashboard/${key}`,
              })
            }
            activeKey={status}
            style={padfix}
            tabBarGutter={50}
            tabBarExtraContent={{ left: <div className={'TabPaneTitle'} style={status.startsWith('datatracker_') ? navMenuHeaderStyle.style1 : navMenuHeaderStyle.style0}>&nbsp;&nbsp;&nbsp;Data Entry Tracker&nbsp;&nbsp;&nbsp;</div> }}

          >
            {!isExternalContributorOrExternalView() && (
              <TabPane
                tab={<div className={'TabPaneTitle'}>All</div>}
                key='datatracker_all'
              />
            )}

            {!isExternalContributorOrExternalView() && (
              <TabPane
                tab={<div className={'TabPaneTitle'}>In Pending</div>}
                key='datatracker_pending'
              />
            )}
            {!isExternalContributorOrExternalView() && (
              <TabPane
                tab={<div className={'TabPaneTitle'}>In Progress</div>}
                key='datatracker_progress'
              />
            )}
            {!isExternalContributorOrExternalView() && (
              <TabPane
                tab={<div className={'TabPaneTitle'}>On Hold</div>}
                key='datatracker_hold'
              />
            )}
            {!isExternalContributorOrExternalView() && (
              <TabPane
                tab={<div className={'TabPaneTitle'}>NA</div>}
                key='datatracker_na'
              />
            )}
            {!isExternalContributorOrExternalView() && (
              <TabPane
                tab={<div className={'TabPaneTitle'}>Complete</div>}
                key='datatracker_complete'
              />
            )}
            {!isExternalContributorOrExternalView() && (
              <TabPane
                tab={<div className={'TabPaneTitle'}>Matched/Duplicate</div>}
                key='datatracker_matched-duplicate'
              />
            )}
          </Tabs>}
          {tclApplicationMenu &&
            <Tabs
              centered
              defaultActiveKey={match.params.tabId}
              onTabClick={(key) =>
                history.push({
                  pathname: `/dashboard/${key}`,
                })
              }
              activeKey={status}
              style={padfix}
              tabBarGutter={40}
              tabBarExtraContent={{ left: <div className={'TabPaneTitle'} style={!status.startsWith('datatracker_') && !status.startsWith('fmptracker_') ? navMenuHeaderStyle.style1 : navMenuHeaderStyle.style0}>Transmission Checklist</div> }}
            >
              {/* {!isExternalContributorOrExternalView() &&
                        <TabPane tab={<div className={"TabPaneTitle"}>IPS Data Tracker</div>} key="ipsdatatracker" />} */}

              {!isExternalContributorOrExternalView() && (
                <TabPane
                  tab={<div className={'TabPaneTitle'}>All</div>}
                  key='all'
                />
              )}
              {!isExternalContributorOrExternalView() && (
                <TabPane
                  tab={<div className={'TabPaneTitle'}>Upcoming</div>}
                  key='upcoming'
                />
              )}
              {!isExternalContributorOrExternalView() && (
                <TabPane
                  tab={<div className={'TabPaneTitle'}>In-Development</div>}
                  key='development'
                />
              )}
              {!isExternalContributorOrExternalView() && (
                <TabPane
                  tab={<div className={'TabPaneTitle'}>Released</div>}
                  key='release'
                />
              )}
              <TabPane
                tab={<div className={'TabPaneTitle'}>Active</div>}
                key='active'
              />
              <TabPane
                tab={<div className={'TabPaneTitle'}>Closed</div>}
                key='closed'
              />
              {!isExternalContributorOrExternalView() && (
                <TabPane
                  tab={<div className={'TabPaneTitle'}>Checklist NA</div>}
                  key='checklist_na'
                />
              )}
              {/*isCreatorOrAdministrator() && (
                <TabPane
                  tab={<div className={'TabPaneTitle'}>Admin</div>}
                  key='admin'
                />
              )*/}
            </Tabs>
          }
           {!isExternalContributorOrExternalView() && fmpApplicationMenu && <Tabs
            centered
            defaultActiveKey={match.params.tabId}
            onTabClick={(key) =>
              history.push({
                pathname: `/dashboard/${key}`,
              })
            }
            activeKey={status}
            style={padfix}
            tabBarGutter={50}
            tabBarExtraContent={{ left: <div className={'TabPaneTitle'} style={status.startsWith('fmptracker_') ? navMenuHeaderStyle.style1 : navMenuHeaderStyle.style0}>&nbsp;&nbsp;&nbsp;FMP Tracker&nbsp;&nbsp;&nbsp;</div> }}

          >
            {!isExternalContributorOrExternalView() && (
              <TabPane
                tab={<div className={'TabPaneTitle'}>All</div>}
                key='fmptracker_all'
              />
            )}

            {!isExternalContributorOrExternalView() && (
              <TabPane
                tab={<div className={'TabPaneTitle'}>Pending</div>}
                key='fmptracker_pending'
              />
            )}
            {!isExternalContributorOrExternalView() && (
              <TabPane
                tab={<div className={'TabPaneTitle'}>In Progress</div>}
                key='fmptracker_progress'
              />
            )}
            {!isExternalContributorOrExternalView() && (
              <TabPane
                tab={<div className={'TabPaneTitle'}>Under Review</div>}
                key='fmptracker_review'
              />
            )}
            {!isExternalContributorOrExternalView() && (
              <TabPane
                tab={<div className={'TabPaneTitle'}>As-Builts</div>}
                key='fmptracker_asbuilts'
              />
            )}
            {!isExternalContributorOrExternalView() && (
              <TabPane
                tab={<div className={'TabPaneTitle'}>Complete</div>}
                key='fmptracker_complete'
              />
            )}
          </Tabs>}
        </div>
      </>
    );
  }
}
ProjectTabRoutes.contextType = CommToolContext;
export default withRouter(ProjectTabRoutes);